import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";

export default function TableBulkEditButton({
  visible,
  disabled,
  label,
  title,
  onClick,
}) {
  if (!visible) {
    return null;
  }

  return (
    <Tooltip title={title || ""} disableHoverListener={!title}>
      <span>
        <Button
          variant="contained"
          size="small"
          disabled={disabled}
          onClick={onClick}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}

TableBulkEditButton.propTypes = {
  visible: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

TableBulkEditButton.defaultProps = {
  visible: true,
  disabled: false,
  title: undefined,
};
